/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/rodeos-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/rodeos-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/rodeos-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-rodeos-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/rodeos.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-09-17T23:32:24.821Z
 * Source config: config/entities/rodeos-entity-config.ts
 * Public fields: 38/38 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const RodeosSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  name: Type.Union([Type.String(), Type.Null()]), // name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  start_date: Type.Union([Type.String(), Type.Null()]), // start_date field
  end_date: Type.Union([Type.String(), Type.Null()]), // end_date field
  primary_organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // primary_organization_id field
  url: Type.Union([Type.String(), Type.Null()]), // url field
  slack_time: Type.Union([Type.String(), Type.Null()]), // slack_time field
  metadata: Type.Union([Type.String(), Type.Null()]), // metadata field
  is_published: Type.Union([Type.Boolean(), Type.Null()]), // is_published field
  rodeo_or_jackpot: Type.Union([Type.String(), Type.Null()]), // rodeo_or_jackpot field
  default_handicap_organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // default_handicap_organization_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field
  buddy_groups_enabled: Type.Boolean(), // buddy_groups_enabled field
  max_buddy_group_size: Type.Number(), // max_buddy_group_size field
  member_only_buddy_groups: Type.Boolean(), // member_only_buddy_groups field
  duplicate_detection_mode: Type.String(), // duplicate_detection_mode field
  allow_non_member_buddy_group: Type.Boolean(), // allow_non_member_buddy_group field
  non_member_surcharge: Type.Union([Type.Number(), Type.Null()]), // non_member_surcharge field
  allow_cash_payment: Type.Boolean(), // allow_cash_payment field
  preference_config: Type.Union([Type.String(), Type.Null()]), // preference_config field
  entry_close_time: Type.String(), // entry_close_time field
  fees_due_message: Type.Union([Type.String(), Type.Null()]), // fees_due_message field
  location: Type.Union([Type.String(), Type.Null()]), // location field
  timezone: Type.String(), // timezone field
  draw_mode: Type.String(), // draw_mode field
  scoring_state: Type.String(), // scoring_state field
  scoring_went_live_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // scoring_went_live_at field
  scoring_went_live_by: Type.Union([Type.String(), Type.Null()]), // scoring_went_live_by field
  member_fee_enabled: Type.Union([Type.Boolean(), Type.Null()]), // member_fee_enabled field
  allow_pay_later: Type.Boolean(), // allow_pay_later field
  cancelled_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // cancelled_at field
  cancelled_by: Type.Union([Type.String(), Type.Null()]), // cancelled_by field
  cancellation_reason: Type.Union([Type.String(), Type.Null()]), // cancellation_reason field
  is_finals: Type.Boolean(), // is_finals field
});

export const CreateRodeosSchema = Type.Object({
  name: Type.Union([Type.String(), Type.Null()]), // name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  start_date: Type.Union([Type.String(), Type.Null()]), // start_date field
  end_date: Type.Union([Type.String(), Type.Null()]), // end_date field
  primary_organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // primary_organization_id field
  url: Type.Union([Type.String(), Type.Null()]), // url field
  slack_time: Type.Union([Type.String(), Type.Null()]), // slack_time field
  metadata: Type.Optional(Type.Union([Type.String(), Type.Null()])), // metadata field
  is_published: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])), // is_published field
  rodeo_or_jackpot: Type.Union([Type.String(), Type.Null()]), // rodeo_or_jackpot field
  default_handicap_organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // default_handicap_organization_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  buddy_groups_enabled: Type.Optional(Type.Boolean()), // buddy_groups_enabled field
  max_buddy_group_size: Type.Optional(Type.Number()), // max_buddy_group_size field
  member_only_buddy_groups: Type.Optional(Type.Boolean()), // member_only_buddy_groups field
  duplicate_detection_mode: Type.Optional(Type.String()), // duplicate_detection_mode field
  allow_non_member_buddy_group: Type.Optional(Type.Boolean()), // allow_non_member_buddy_group field
  non_member_surcharge: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // non_member_surcharge field
  allow_cash_payment: Type.Optional(Type.Boolean()), // allow_cash_payment field
  preference_config: Type.Union([Type.String(), Type.Null()]), // preference_config field
  entry_close_time: Type.String(), // entry_close_time field
  fees_due_message: Type.Union([Type.String(), Type.Null()]), // fees_due_message field
  location: Type.Union([Type.String(), Type.Null()]), // location field
  timezone: Type.Optional(Type.String()), // timezone field
  draw_mode: Type.Optional(Type.String()), // draw_mode field
  scoring_state: Type.Optional(Type.String()), // scoring_state field
  scoring_went_live_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // scoring_went_live_at field
  scoring_went_live_by: Type.Union([Type.String(), Type.Null()]), // scoring_went_live_by field
  member_fee_enabled: Type.Union([Type.Boolean(), Type.Null()]), // member_fee_enabled field
  allow_pay_later: Type.Optional(Type.Boolean()), // allow_pay_later field
  cancelled_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // cancelled_at field
  cancelled_by: Type.Union([Type.String(), Type.Null()]), // cancelled_by field
  cancellation_reason: Type.Union([Type.String(), Type.Null()]), // cancellation_reason field
  is_finals: Type.Optional(Type.Boolean()), // is_finals field
});

export const UpdateRodeosSchema = Type.Object({
  name: Type.Union([Type.String(), Type.Null()]), // name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  start_date: Type.Union([Type.String(), Type.Null()]), // start_date field
  end_date: Type.Union([Type.String(), Type.Null()]), // end_date field
  primary_organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // primary_organization_id field
  url: Type.Union([Type.String(), Type.Null()]), // url field
  slack_time: Type.Union([Type.String(), Type.Null()]), // slack_time field
  metadata: Type.Union([Type.String(), Type.Null()]), // metadata field
  is_published: Type.Union([Type.Boolean(), Type.Null()]), // is_published field
  rodeo_or_jackpot: Type.Union([Type.String(), Type.Null()]), // rodeo_or_jackpot field
  default_handicap_organization_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // default_handicap_organization_id field
  created_by: Type.Union([Type.String(), Type.Null()]), // created_by field
  updated_by: Type.Union([Type.String(), Type.Null()]), // updated_by field
  buddy_groups_enabled: Type.Boolean(), // buddy_groups_enabled field
  max_buddy_group_size: Type.Number(), // max_buddy_group_size field
  member_only_buddy_groups: Type.Boolean(), // member_only_buddy_groups field
  duplicate_detection_mode: Type.String(), // duplicate_detection_mode field
  allow_non_member_buddy_group: Type.Boolean(), // allow_non_member_buddy_group field
  non_member_surcharge: Type.Union([Type.Number(), Type.Null()]), // non_member_surcharge field
  allow_cash_payment: Type.Boolean(), // allow_cash_payment field
  preference_config: Type.Union([Type.String(), Type.Null()]), // preference_config field
  entry_close_time: Type.String(), // entry_close_time field
  fees_due_message: Type.Union([Type.String(), Type.Null()]), // fees_due_message field
  location: Type.Union([Type.String(), Type.Null()]), // location field
  timezone: Type.String(), // timezone field
  draw_mode: Type.String(), // draw_mode field
  scoring_state: Type.String(), // scoring_state field
  scoring_went_live_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // scoring_went_live_at field
  scoring_went_live_by: Type.Union([Type.String(), Type.Null()]), // scoring_went_live_by field
  member_fee_enabled: Type.Union([Type.Boolean(), Type.Null()]), // member_fee_enabled field
  allow_pay_later: Type.Boolean(), // allow_pay_later field
  cancelled_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // cancelled_at field
  cancelled_by: Type.Union([Type.String(), Type.Null()]), // cancelled_by field
  cancellation_reason: Type.Union([Type.String(), Type.Null()]), // cancellation_reason field
  is_finals: Type.Boolean(), // is_finals field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type RodeosRow = Static<typeof RodeosSchema>;
export type RodeosInsert = Static<typeof CreateRodeosSchema>;
export type RodeosUpdate = Static<typeof UpdateRodeosSchema>;

// Legacy type aliases for backward compatibility
export type Rodeos = RodeosRow;
export type CreateRodeos = RodeosInsert;
export type UpdateRodeos = Static<typeof UpdateRodeosSchema>;

// Field configuration metadata
export const RodeosFieldConfig = {
  filterable: ['id', 'primary_organization_id', 'default_handicap_organization_id'] as const,
  sortable: ['start_date', 'end_date', 'created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'buddy_groups_enabled', 'max_buddy_group_size', 'member_only_buddy_groups', 'duplicate_detection_mode', 'allow_non_member_buddy_group', 'allow_cash_payment', 'entry_close_time', 'timezone', 'draw_mode', 'scoring_state', 'allow_pay_later', 'is_finals'] as const,
  readonly: ['id', 'created_at', 'updated_at'] as const,
} as const;
